import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import Button from '../../../../_common/Form/Buttons/Button';
import classes from './statusForm.module.scss';
import InputField from '../../../../_common/Form/TextFields/InputField';
import DOBPicker from '../../../../_common/Form/DatePickers/DOBPicker/DOBPicker';

const ReviewStatus = ({
  changeStatus, info, openCancelModal, statusProcess,
}) => {
  const [formData, setFormData] = useState({});
  const [statusForm, setStatusForm] = useState('');
  const [dateError, setDateError] = useState('');

  const setNewStatusForm = (status) => {
    if (status === 'reversal' || status === 'transfer') {
      setDateError('');

      setStatusForm((prev) => {
        if (prev !== status) {
          if (status === 'reversal') {
            setFormData({ processedOn: info.processedOn });
          } else {
            setFormData({ location: info.location, transNPI: info.transNPI, transDate: info.transDate });
          }

          return status;
        }

        setFormData({});
        return '';
      });
    }
  };

  const setDate = (path, value) => {
    setFormData((prev) => ({ ...prev, [path]: value }));

    setDateError('');
  };

  const setStatus = (status, withDataInForm) => {
    let hasError = false;

    if (statusForm === 'reversal' && formData.processedOn && formData.processedOn.length !== 10) {
      setDateError('Invalid date');

      hasError = true;
    } else if (statusForm === 'transfer' && formData.transDate && formData.transDate.length !== 10) {
      setDateError('Invalid date');

      hasError = true;
    }

    if (hasError) {
      toast.error('Please fill this fields');
    } else {
      let data = { status };

      if (withDataInForm) {
        data = { ...data, ...formData };
      }

      changeStatus(data);
      setStatusForm('');
    }
  };

  return (
    <div className={classes.status_wrapper}>
      <p>
        {statusProcess
          ? 'Please process the script then specify what to do next.'
          : 'Review this script. Then specify what to do next.'}
      </p>

      <div className={classes.btns_wrapper}>
        <Button
          className={classes.max_content}
          title="Ready to schedule"
          scheduleButton
          onClick={() => setStatus('Schedule')}
        />

        <Button
          className={classes.max_content}
          title="Needs prior authorization"
          authorizationButton
          onClick={() => setStatus('Prior Auth')}
        />

        <Button
          className={classes.max_content}
          title="Needs co-pay assistance"
          copayButton
          onClick={() => setStatus('Copay Assistance')}
        />

        {!statusProcess
          && (
          <>
            <Button
              className={classes.max_content}
              title="Ready to process"
              processButton
              onClick={() => setStatus('Process')}
            />

            <Button
              className={classes.max_content}
              title="Flag for reversal"
              reversalButton
              onClick={() => setNewStatusForm('reversal')}
            />

            <Button
              className={classes.max_content}
              title="Transfer"
              transferButton
              onClick={() => setNewStatusForm('transfer')}
            />
          </>
          )}

        {statusProcess && (
          <Button
            className={classes.max_content}
            title="Flag for review"
            reviewButton
            onClick={() => setStatus('Review')}
          />
        )}
      </div>

      {!statusProcess && statusForm === 'reversal'
        && (
          <div className={classes.form}>
            <div>
              <p>
                { statusProcess
                  ? 'Please process the script then specify what to do next.'
                  : 'Reverse the script and specify when it should be processed.'}
              </p>

              <DOBPicker
                wrapperClassName={classes.date_picker}
                label="Process On"
                hideClearButton
                date={formData.processedOn}
                dateFormat="YYYY-MM-DD"
                labelBG="#f6f8fa"
                onChange={(date) => setDate('processedOn', date)}
                autoValidation={false}
                error={dateError}
              />

              <div className={classes.btns_wrapper}>
                <Button
                  title="Reverse script"
                  reverseColor
                  onClick={() => setStatus('Process', true)}
                />

                <Button
                  title="Cancel script"
                  clearButton
                  onClick={openCancelModal}
                />
              </div>
            </div>
          </div>
        )}

      {!statusProcess && statusForm === 'transfer'
        && (
          <div className={classes.form}>
            <div style={{ marginTop: 7 }}>
              <InputField
                labelBG="#f6f8fa"
                label="Location"
                value={formData.location || ''}
                onChange={(value) => setFormData((prev) => ({ ...prev, location: value }))}
              />

              <InputField
                labelBG="#f6f8fa"
                label="NPI"
                value={formData.transNPI || ''}
                onChange={(value) => setFormData((prev) => ({ ...prev, transNPI: value }))}
              />

              <DOBPicker
                labelBG="#f6f8fa"
                wrapperClassName={classes.date_picker}
                label="Date"
                date={formData.transDate || ''}
                dateFormat="YYYY-MM-DD"
                onChange={(date) => setDate('transDate', date)}
                autoValidation={false}
                error={dateError}
              />

              <Button
                title="Transfer"
                reverseColor
                onClick={() => setStatus('Cancelled', true)}
              />
            </div>
          </div>
        )}
    </div>
  );
};

ReviewStatus.propTypes = {
  info: PropTypes.object.isRequired,
  changeStatus: PropTypes.func.isRequired,
  openCancelModal: PropTypes.func.isRequired,
  statusProcess: PropTypes.bool,
};

ReviewStatus.defaultProps = {
  statusProcess: false,
};

export default ReviewStatus;
